import client from '@libs/HttpClient';
class RecruitmentInterviewStatus {
  static listRecruitmentInterviewStatus(request) {
    const page_no = request.queryKey[1];
    const searchText = request.queryKey[2];
    const status = request.queryKey[3];
    return client.get(
      `/recruitment-interview-status/?search=${searchText}&page=${page_no}&status=${status}`,
      request
    );
  }
  static addRecruitmentInterviewStatus(request) {
    return client.post('/recruitment-interview-status', request);
  }
  static showRecruitmentInterviewStatus(params) {
    return client.get(`/recruitment-interview-status/${params}`);
  }
  static viewRecruitmentInterviewStatus(params) {
    return client.get(`/recruitment-interview-status/${params}/edit`);
  }
  static updateRecruitmentInterviewStatus(request) {
    return client.put(`/recruitment-interview-status/${request.id}`, request);
  }
  static deleteRecruitmentInterviewStatus(request) {
    return client.delete(`/recruitment-interview-status/${request.id}`, request);
  }
  static changeStatusRecruitmentInterviewStatus(request) {
    return client.patch(`/recruitment-interview-status/custom/change-status/${request.id}`, request);
  }
  static getMaxSequenceNumber() {
    return client.get(`/recruitment-interview-status/custom/get-max-sequence-no`);
  }
  static updateTaskStatusTypeSequenceAndShift(request) {
    return client.put(`/recruitment-interview-status/custom/update-sequence-shift`, request);
  }
  static getExistingSequenceTaskStatusTypes(interviewStatusId  = '') {
    return client.get(`/recruitment-interview-status/custom/get-existing-sequences/${interviewStatusId}`);
  }
}
export { RecruitmentInterviewStatus };
